import { SelectOptionType } from '@octano/global-ui';
import {
  ClassroomBlockingReason,
  ClassroomSelectOptionType,
  RecordToEditBody,
} from './types';

export const getSelectOptionsFromData = (
  items?: ClassroomSelectOptionType[] | null,
): SelectOptionType[] => {
  if (!items || !Array.isArray(items)) {
    return [];
  }
  return items.map((item) => ({
    label: item.name,
    value: item.id,
  }));
};

export const getDefaultValues = (recordToEdit?: RecordToEditBody) => {
  return recordToEdit
    ? {
        code: recordToEdit.code,
        name: recordToEdit.name,
        capacity: recordToEdit.capacity,
        description: recordToEdit.description ?? '',
        type: { label: recordToEdit.type.name, value: recordToEdit.typeId },
        campus: {
          label: recordToEdit.campus.name,
          value: recordToEdit.campusId,
        },
        typeId: recordToEdit.typeId,
      }
    : {
        code: '',
        name: '',
        capacity: 0,
        description: '',
        type: null,
        campus: null,
      };
};

/**
 * Lee el motivo de bloqueo del cuerpo de un 409 de la API.
 *
 * El listado ya trae `hasPastReservations` y `currentOrFutureReservations`, así
 * que en el caso normal el portal decide qué modal abrir sin preguntar. Esto
 * cubre el caso en que la pantalla quedó vieja: alguien reservó la sala
 * mientras esta pestaña estaba abierta y la acción llega tarde.
 */
export function getClassroomBlockingReason(result: {
  error?: unknown;
}): ClassroomBlockingReason | null {
  const reason = (result?.error as any)?.error?.response?.data?.reason;
  if (
    reason === ClassroomBlockingReason.HasCurrentOrFutureReservations ||
    reason === ClassroomBlockingReason.HasPastReservations
  ) {
    return reason;
  }
  return null;
}
